import React from 'react';

interface ReturnArrowIconProps {
  width?: number | string;
  height?: number | string;
  stroke?: string;
  strokeWidth?: number | string;
  className?: string;
  onClick?: () => void;
}

const ReturnArrowIcon: React.FC<ReturnArrowIconProps> = ({
  width = 20,
  height = 20,
  stroke = '#91B1BE',
  strokeWidth = 1.5,
  className = '',
  onClick,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      className={className}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <path
        d='M13.7417 10L16.8667 13.125M16.8667 13.125L13.7417 16.25M16.8667 13.125H3.1167V3.74917'
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ReturnArrowIcon;
